import { Font18 } from 'components/Typography'
import { Form } from 'formik'
import styled from 'styled-components'

import theme from 'theme_'

export const StyledWLANForm = styled(Form)`
  width: 100%;
  min-height: 500px;
`

export const WLANFormSSIDInputs = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 700px;
  gap: ${theme.spacing.base};

  & > div {
    flex-basis: 100%;
  }

  @media ${theme.devices.tablet} {
    flex-wrap: nowrap;
    & > div {
      flex-basis: 50%;
    }
  }
`

export const WLANFormPSKsInputs = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 700px;
  gap: ${theme.spacing.base};

  & > div {
    flex-basis: 100%;
  }

  @media ${theme.devices.tablet} {
    flex-wrap: nowrap;
    & > div {
      flex-basis: 50%;
    }
  }
`

export const WLANFormPSKsPassword = styled.div`
  min-width: 300px;
`

export const WLANFormPSKVlanTitle = styled.div`
  font-size: 12px;
  white-space: nowrap;
  margin-bottom: ${theme.spacing.base};
  text-align: right;
`

export const WLANFormHeading = styled.h2`
  word-break: word;
`

export const WLANFormSSIDName = styled.div``

export const WLANFormBlock = styled.div`
  margin: ${theme.spacing.md} 0;
`
export const WLANFormBlockSub = styled.div``

export const WLANFormBlockSubgroup = styled.div`
  margin: ${theme.spacing.md} 0;
  background-color: ${theme.colors.lightGrey};
  padding: ${theme.spacing.md};
`

export const WLANFormSeparator = styled.div`
  height: 1px;
  background-color: ${theme.colors.lightGrey};
`
export const WLANFormSpacer = styled.span`
  height: 20px;
  width: 150px;
  margin-left: 35px;
`

export const WLANFormSubTitle = styled.div`
  ${Font18}
  margin-bottom: ${theme.spacing.base};
`

export const WLANFormGuestTimeInputs = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 700px;
  gap: ${theme.spacing.base};

  & > div {
    flex-basis: 100%;
  }

  @media ${theme.devices.tablet} {
    flex-wrap: nowrap;
    & > div {
      flex-basis: 50%;
    }
  }
`

export const WLANFormGuestTimeAmountInputs = styled.div`
  max-width: 96px;
`

export const WLANFormGuestTimeAmountDropdown = styled.div`
  max-width: 150px;
`

export const WLANBonjourWrapperInputs = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 700px;
  gap: ${theme.spacing.base};
  margin: ${theme.spacing.tiny} 0;
  & > div {
    flex-basis: 100%;
  }

  @media ${theme.devices.tablet} {
    flex-wrap: nowrap;
    & > div {
      flex-basis: 50%;
    }
  }
`
export const WLANBonjourInputs = styled.div`
  max-width: 350px;
`
